import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Tooltip,
  Typography,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { SelectResult } from '../../../components/select/select-chain.component';
import { ServiceList } from './service-list';
import { useSaveData } from '../../../hooks/useSaveData';
import { workOrdersApiKeyStore } from '../../../api/workorders-api-key-store';
import { useState } from 'react';
import { FormCheckbox } from '../../../components/hook-form/form-checkbox.component';
import { WorkOrder } from '../../../models/workOrder';
import { useAuthorize } from '../../../hooks/use-authorize';
import { UserPermissionName } from '../../../models/user-permission-name';

const styling = {
  dialogTitleStyle: { padding: '16px 24px 0' },
  contentPadding: { paddingTop: '15px' },
  buttonPadding: { paddingTop: '20px' },
  tabHeading: { fontWeight: 'bold' },
  buttonStyle: { width: '130px' },
};

interface CreateWorkorderDialogProps {
  open: boolean;
  onClose: () => void;
  workOrder?: WorkOrder;
  unitID?: number;

  selectedServiceID: number;
  onHandleSetSelectedServiceId: (value: number, fastFieldFormIDValue: number) => void;
  handleServiceSave: () => void;
}

export const SelectServiceDialog = ({
  open,
  onClose,
  workOrder,
  unitID,
  handleServiceSave,
  selectedServiceID,
  onHandleSetSelectedServiceId,
}: CreateWorkorderDialogProps) => {
  const [isOrginalService, setIsOrginalService] = useState<boolean>(false);
  const handleDialogClose = () => {
    onClose();
  };
  const { isLoading: isSaving, mutateAsync } = useSaveData(workOrdersApiKeyStore.switchService());

  const handleSaveClick = async () => {
    handleServiceSave();
  };

  const handleSetSelectedServiceId = (value: number, fastFieldFormIDValue: number) => {
    onHandleSetSelectedServiceId(value, fastFieldFormIDValue);
    setIsOrginalService(false);
  };

  const handleSelectOrginalServiceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setIsOrginalService(isChecked);
    if (isChecked) {
      onHandleSetSelectedServiceId(
        !workOrder?.originalServiceID ? 0 : workOrder?.originalServiceID,
        !workOrder?.originalFastFieldFormID ? 0 : workOrder?.originalFastFieldFormID
      );
    } else {
      onHandleSetSelectedServiceId(0, 0);
    }
  };

  console.log(77, selectedServiceID);

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'sm'}
      // onClose={handleDialogClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title" style={styling.dialogTitleStyle}>
        Service Mapping
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleDialogClose}
        sx={{
          position: 'absolute',
          right: 10,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers style={styling.contentPadding} className="popupDilog selectServiceList">
        <p style={{ marginBottom: '25px', lineHeight: '20px' }}>
          <strong>
            Service is not mapped to this work order. You need to map a service before updating the status.
            {/* Service is not mapped to this work order. You can map the service by either selecting the original service */}
          </strong>{' '}
          {/* <strong>or one from the service list below.</strong> */}
        </p>
        <FormControlLabel
          control={
            <Checkbox
              checked={isOrginalService} // Explicitly set the checked state
              onChange={handleSelectOrginalServiceChange}
            />
          }
          label={`Select Initial Service- ${workOrder?.originalServiceName}`}
        />
        <p style={{ padding: '5px 15px' }}>or</p>
        <div style={{ marginTop: '15px' }}>
          <ServiceList
            isOrginalService={isOrginalService}
            name="serviceData"
            unitID={unitID}
            handleSetSelectedServiceId={handleSetSelectedServiceId}
          />
        </div>
      </DialogContent>
      <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
        <DialogActions className="spaceBetween">
          <Button variant="outlined" style={{ width: '130px' }} onClick={handleDialogClose}>
            Cancel
          </Button>
          <Button
            type={'button'}
            variant="contained"
            disableElevation={true}
            style={styling.buttonStyle}
            disabled={isSaving || !selectedServiceID || isReadOnlyPermission}
            onClick={handleSaveClick}
          >
            Save
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
